export class ExportError extends Error {
  constructor(code, message = code) {
    super(message);
    this.name = 'ExportError';
    this.code = code;
  }
}

export function requireExport(condition, code, message) {
  if (!condition) throw new ExportError(code, message);
}
